<template>
  <div class="filters-container">
    <!-- 产品名称筛选 -->
    <template v-if="currentFilter === 1">
      <el-input
        size="small"
        v-model="nameValue"
        placeholder="请输入产品名称"
        style="width: 200px;"
        clearable
        @input="handleInput"
      />
    </template>
    
    <!-- 产品类别筛选 -->
    <template v-if="currentFilter === 2">
      <el-select
        size="small"
        v-model="typeValue"
        placeholder="请选择产品类别"
        style="width: 200px;"
        clearable
        @change="handleChange"
      >
        <el-option
          v-for="item in frequencyTypeList"
          :key="item.id"
          :label="item.text"
          :value="item.id"
        />
      </el-select>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ProductFilters',
  props: {
    currentFilter: {
      type: Number,
      default: 1
    },
    value: {
      type: [String, Number],
      default: ''
    },
    frequencyTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      nameValue: '',
      typeValue: ''
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        if (this.currentFilter === 1) {
          this.nameValue = val || '';
        } else if (this.currentFilter === 2) {
          this.typeValue = val || '';
        }
      }
    },
    currentFilter(newVal) {
      // 切换筛选类型时清空值
      this.nameValue = '';
      this.typeValue = '';
      this.$emit('input', '');
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
    },
    handleChange(val) {
      this.$emit('input', val);
    }
  }
}
</script>

<style scoped>
.filters-container {
  display: inline-block;
}
</style>